 
<div [formGroup]="partquantityForm" novalidate>
<div class="modal-header  col-sm-12" >
  <h4 class="modal-title col-sm-8">Quantity Management</h4>
  <div class="text-right  col-sm-4" style="padding:0">
    <button type="button" class="btn btn-primary grayButton"  (click)="saveAndClose()">Close</button>
  </div>
</div>

  <div class="modal-body">
    <div class="box-row col-sm-10 col-sm-offset-2">
        <span [ngClass]="'error'" *ngIf="errormsg" >
          {{errormsg}}
        </span>
    </div>
    <div class="col-sm-12 box-row">
        <label class="col-sm-5 control-label">Date:</label>
        <div class="col-sm-7">
          <label class="readOnlyText">{{today | date:'dd/MM/yyyy'}}</label>
        </div>
    </div>

  <div class="col-sm-12 box-row">
    <label class="col-sm-5 control-label">Total Quantity:</label>
    <div class="col-sm-4">
      <label class="readOnlyText">{{ totalQuantity }}</label>
    </div>
    <div class="col-sm-3" *ngIf="this.data?.equipementId != 0 &&  this.data?.fromInventoryPage">
      <button *ngIf="!showNewQty"
          title="Update"
          type="button"
          class="btn btn-primary grayButton"
          (click)="onUpdateClick()">Update</button>

      <button *ngIf="showNewQty"
              title="Cancel"
              type="button"
              class="btn btn-primary grayButton"
              (click)="onCancelUpdateClick()">Cancel</button>
    </div>
  </div>
<!-- 
  <div class="col-sm-12 box-row">
    <label class="col-sm-5 control-label">Remaining Quantity:</label>
    <div class="col-sm-7">
      <label class="readOnlyText">{{ remainingQuantity }}</label>
    </div>
  </div> -->
  
  <div>
 
    <div class="col-sm-12 box-row">
   <div class="col-sm-5 d-flex flex-column">
    <!-- Top -->
    <div class="d-flex align-items-center mb-3"> <!-- added margin-bottom -->
      <label class="control-label mb-0">
        Available Quantity:
      </label>
    </div>

    <!-- Bottom -->
   <div class="d-flex justify-content-center align-items-center mt-3" style="margin-top: 120px;">
  <label class="control-label mb-0 me-2">
    Unassigned Quantity:
  </label>
  <input type="number"
         class="form-control"
         formControlName="unassignedQty"
         [readonly]="true"
         style="width: 80px; text-align: center; background-color: #f8f9fa;margin-top: 4px;margin-left: 30px;"> 
</div>
</div>
     
  <div class="col-sm-7">
    <table class="table table-bordered table-condensed">
      <thead>
        <tr>
          <th>Division</th>
          <th>Qty</th>
          <th [style.display]="showNewQty ? '' : 'none'">New Qty.</th>
        </tr>
      </thead>
      <tbody formArrayName="divisionParts">
       
        <tr *ngFor="let dp of divisionParts.controls; let i = index" [formGroupName]="i" style="vertical-align: middle;">
          <!-- Division Name -->
          
          <td style="padding: 8px 12px; font-weight: 500;">
            <label class="form-control-plaintext" style="margin: 0;">
              {{ dp.get('division')?.value }} 
            </label>
          </td>

          <!-- Quantity -->
          <td style="padding: 8px 12px;">
            <input *ngIf="this.data?.equipementId == 0" type="number"
                   class="form-control"
                   formControlName="quantity"
                   min="0"
                   style="width: 80px; text-align: right;"> 
            <input *ngIf="this.data?.equipementId != 0" type="number"
                   class="form-control"
                   formControlName="quantity"
                   min="0"
                   [readonly]="this.data?.equipementId != 0"
                   style="width: 80px; text-align: right; background-color: #f8f9fa;"> 
          </td>

          <!-- New Quantity -->
          <td *ngIf="showNewQty" style="padding: 8px 12px;">
            <input type="number"
                   class="form-control"
                   formControlName="newQuantity"
                   style="width: 80px; text-align: right;" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
    
</div>


<div class="col-sm-12 box-row" *ngIf="this.data?.fromInventoryPage">
    <label class="col-sm-5"></label>
    <div class="col-sm-4">
    </div>
    <div class="col-sm-3">
      <button title="Save" type="button" class="btn btn-primary grayButton"  (click)="saveAndClose()">Save</button>
    </div>
</div>

</div>
</div>
</div>
